
import { defineComponent, reactive } from 'vue'
import AppHeader from '@/components/AppHeader.vue'
import CardList from '@/components/CardList.vue'
import RecentPayments from '@/components/RecentPayments.vue'
import PaymentDetail from '@/components/PaymentDetail.vue'
import { CardType } from '@/types/Card'
import { PaymentAction, RecentPayment } from '@/types/RecentPayment'

export default defineComponent({
  components: {
    AppHeader,
    CardList,
    RecentPayments,
    PaymentDetail,
  },
  setup() {
    // TODO(Initialize data from file or API ?!)
    const cards = reactive<CardType[]>([])
    const recentPayments = reactive<RecentPayment[]>([
      {
        id: 1,
        name: 'Charge Back',
        action: 'payment',
        date: 'Mar 20, 2021',
        amount: '-$140,20',
      },
      {
        id: 2,
        name: 'Information Requested for a payment',
        action: 'refund',
        date: 'Mar 20, 2021',
        amount: '+$40,20',
      },
      {
        id: 3,
        name: 'Settled',
        action: 'payment',
        date: 'Mar 20, 2021',
        amount: '-$74,70',
      },
      {
        id: 4,
        name: 'Authorized',
        action: 'credit',
        date: 'Mar 19, 2021',
        amount: '-$1,20',
      },
    ])

    const addRecentPayment = () => {
      const nextId =
        Math.max(...recentPayments.map((recentPayment) => recentPayment.id)) + 1

      recentPayments.unshift({
        id: nextId,
        name: 'Charge Comes Back',
        action: 'payment',
        date: 'Mar 21, 2021',
        amount: '-$200',
      })
    }

    return {
      cards,
      recentPayments,
      addRecentPayment,
    }
  },
})
